// Bundle PDP hero: single-track gallery (button nav + IntersectionObserver
// sync), the gift-note reveal/collapse, and the mobile sticky buy bar (its
// own reveal observer, plus a loading-state mirror since the sticky button
// lives outside <product-form> and Dawn's product-form.js never sees it).
(function () {
  var section = document.querySelector('[data-candells-section="bundle-product"]');
  if (!section) return;

  // --- Gallery ------------------------------------------------------------
  var track = section.querySelector('[data-candells-gallery-track]');
  var slides = section.querySelectorAll('[data-candells-slide]');
  var controls = section.querySelectorAll('[data-candells-gallery-control]');

  if (track && controls.length) {
    controls.forEach(function (control) {
      control.addEventListener('click', function () {
        var index = parseInt(control.dataset.slideIndex, 10) || 0;
        track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
      });
    });

    if (slides.length && 'IntersectionObserver' in window) {
      var slideList = Array.prototype.slice.call(slides);
      var controlList = Array.prototype.slice.call(controls);

      var galleryObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var index = slideList.indexOf(entry.target);
            if (index < 0) return;
            controlList.forEach(function (control, controlIndex) {
              control.classList.toggle('is-active', controlIndex === index);
            });
          });
        },
        { root: track, threshold: 0.6 }
      );

      slideList.forEach(function (slide) {
        galleryObserver.observe(slide);
      });
    }
  }

  // --- Gift note ------------------------------------------------------------
  var toggle = section.querySelector('[data-candells-gift-toggle]');
  var fields = section.querySelector('[data-candells-gift-fields]');
  var note = section.querySelector('[data-candells-gift-note]');
  var count = section.querySelector('[data-candells-gift-count]');
  var countValue = section.querySelector('[data-candells-gift-count-value]');

  if (toggle && fields && note) {
    var renderCount = function () {
      if (countValue) countValue.textContent = note.value.length;
    };

    var syncGift = function () {
      var on = toggle.checked;
      fields.hidden = !on;
      note.disabled = !on; // the only thing keeping it out of FormData
      toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (!on) {
        note.value = '';
        renderCount();
      }
    };

    if (count) count.hidden = false; // counter is server-hidden; JS owns it
    syncGift();
    toggle.addEventListener('change', syncGift);
    note.addEventListener('input', renderCount);

    // Reset after a successful add so a second tap doesn't re-send the note.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event.source === 'product-form') {
          toggle.checked = false;
          syncGift();
        }
      });
    }
  }

  // --- Mobile sticky bar ------------------------------------------------------
  var stickyBar = document.querySelector('[data-candells-bundle-sticky]');
  var inlineTrigger = section.querySelector('.candells-bundle-product__form-wrap');
  var inlineBtn = section.querySelector('[data-candells-inline-submit]');
  var stickyBtn = stickyBar ? stickyBar.querySelector('[data-candells-sticky-submit]') : null;

  if (stickyBar && inlineTrigger && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      stickyBar.hidden = !passed;
    }).observe(inlineTrigger);
  }

  // Dawn only manages the loading state for `this.submitButton` inside
  // <product-form> (product-form.js), so the sticky button — associated to
  // the form only via `form=` — never gets it. Mirror it from the inline
  // button's attributes instead.
  if (stickyBtn && inlineBtn && 'MutationObserver' in window) {
    var busyObserver = new MutationObserver(function () {
      var busy = inlineBtn.getAttribute('aria-disabled') === 'true';
      stickyBtn.classList.toggle('loading', busy);
      stickyBtn.setAttribute('aria-disabled', busy);
      var spinner = stickyBtn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !busy);
    });
    busyObserver.observe(inlineBtn, { attributes: true, attributeFilter: ['aria-disabled', 'class'] });
  }

  if (stickyBtn && document.querySelector('cart-drawer')) {
    stickyBtn.setAttribute('aria-haspopup', 'dialog');
  }
})();
